/**
 * Hook to initialize keywords store on app startup
 * Call this once in your root layout or app component
 */

'use client'

import { useEffect } from 'react'
import { useKeywordsStore, useUIStore } from './store'

export function useKeywordsInit() {
  const loadKeywords = useKeywordsStore((state) => state.loadKeywords)
  const uiLanguage = useUIStore((state) => state.uiLanguage)
  
  useEffect(() => {
    // Load/reload keywords when UI language changes
    loadKeywords(uiLanguage)
  }, [loadKeywords, uiLanguage])
}

